import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
// import { environment } from '../environments/environment';
import { AppConfigService } from "./app-config.service";

@Injectable({
  providedIn: "root"
})
export class RestService {
  private baseUrl: string;
  private omEnabled: boolean;

  constructor(private http: HttpClient, private appConfig: AppConfigService) {
    const config = this.appConfig.getConfig();
    this.baseUrl = config ? config.rest_url : "";
    this.omEnabled = config  && config.experimentalFeatures && config.experimentalFeatures.enableOmApi;
  }

  getUrl(apiString) {
    switch (apiString) {
      case 'getProcessedFiles':
        return this.omEnabled ? 'api/v2/admin/files/processed':`${this.baseUrl}api/v1/admin/processed_files` ;
      case 'getSentFiles':
        return this.omEnabled ? 'api/v2/admin/files/sent' :`${this.baseUrl}api/v1/admin/sent_files`;
      default: return null;
    }
  }

  // POST
  userInfo() {
    return this.http.get("/api/inblock/tradetalk/v1/user/login-user-info");
  }

  relationshipsUserInfo() {
    return this.http.get("/api/inblock/tradetalk/v1/user/userInfo");
  }

  postInvoiceExports(invoice_numbers) {
    return this.http.post(this.baseUrl + "api/v1/invoice_exports/", {
      invoice_numbers: invoice_numbers
    });
  }

  postSubmitHoldRequest(purchase_orders_id) {
    return this.http.post(
      this.baseUrl + "api/v1/po/" + purchase_orders_id + "/hold/distributor",
      {}
    );
  }

  postSubmitHoldRemovalRequest(purchase_orders_id) {
    return this.http.post(
      this.baseUrl +
        "api/v1/po/" +
        purchase_orders_id +
        "/hold/distributor/remove",
      {}
    );
  }

  postSubmitCancelRequest(purchase_orders_id) {
    return this.http.post(
      this.baseUrl + "api/v1/po/" + purchase_orders_id + "/cancel/distributor",
      {}
    );
  }

  postSubmitCancelRemovalRequest(purchase_orders_id) {
    return this.http.post(
      this.baseUrl +
        "api/v1/po/" +
        purchase_orders_id +
        "/cancel/distributor/remove",
      {}
    );
  }

  postResendDltMessages(payload) {
    return this.http.post(this.baseUrl + "api/v1/dlt/resend_messages", payload);
  }

  postResetPurchaseOrderById(ourchase_orders_id, payload) {
    return this.http.post(
      `${this.baseUrl}api/v1/po/${ourchase_orders_id}/reset`,
      payload
    );
  }

  // GET
  getProcessedFiles(dateFrom?, dateTo?) {
    let url = this.getUrl("getProcessedFiles");
    if (dateFrom && dateTo) {
      url = `${url}?dateFrom=${dateFrom}&dateTo=${dateTo}`;
    }
    return this.http.get(url);
  }

  getSentFiles(dateFrom?, dateTo?) {
    let url = this.getUrl("getSentFiles");
    if (dateFrom && dateTo) {
      url = `${url}?dateFrom=${dateFrom}&dateTo=${dateTo}`;
    }
    return this.http.get(url);
  }

  getDltMessages() {
    return this.http.get(this.baseUrl + "api/v1/admin/dlt_messages/");
  }

  getPurchaseOrders(blotterType, searchText = "") {
    if (blotterType == "search" && searchText != "") {
      return this.http.get(
        this.baseUrl + "api/v1/po/" + blotterType + "/" + searchText
      );
    }
    if (blotterType != "") {
      return this.http.get(this.baseUrl + "api/v1/po/" + blotterType);
    }

    return this.http.get(this.baseUrl + "api/v1/po/all");
  }

  getPurchaseOrderById(purchase_orders_id) {
    return this.http.get(this.baseUrl + "api/v1/po/" + purchase_orders_id);
  }

  getPurchaseOrderByLookup(quote_id, face_amt) {
    return this.http.get(
      this.baseUrl + "api/v1/po/" + quote_id + "/faceamt/" + face_amt
    );
  }

  getPartsById(purchase_orders_id) {
    return this.http.get(this.baseUrl + "api/v1/parts/" + purchase_orders_id);
  }

  getEventLogById(id) {
    return this.http.get(this.baseUrl + "api/v1/po/" + id + "/logs");
  }

  getUploadsById(id) {
    return this.http.get(this.baseUrl + "api/v1/po/" + id + "/uploads");
  }

  getUsersForMyDistributorEntity() {
    return this.http.get(this.baseUrl + "api/v1/distributors/usersinmyentity");
  }

  getDistyDataForManagement(cust_id) {
    return this.http.get(
      this.baseUrl + "api/v1/distributors/" + cust_id + "/management"
    );
  }

  getShippingNoticesForPO(purchase_orders_id) {
    return this.http.get(
      this.baseUrl + "api/v1/shipping_notices/" + purchase_orders_id
    );
  }

  getInvoicesForPO(purchase_orders_id) {
    return this.http.get(
      this.baseUrl + "api/v1/invoices/" + purchase_orders_id
    );
  }

  getInvoicesForExport() {
    return this.http.get(this.baseUrl + "api/v1/invoice_exports/");
  }

  getInvoicesExportsStatus(invoice_numbers) {
    return this.http.get(
      this.baseUrl + "api/v1/invoice_exports_status/" + invoice_numbers
    );
  }

  getItemsForShippingNotice(shipping_notice_id) {
    return this.http.get(
      this.baseUrl + "api/v1/shipping_notices/items/" + shipping_notice_id
    );
  }

  get_items_for_invoice(invoice_id) {
    return this.http.get(this.baseUrl + "api/v1/invoices/items/" + invoice_id);
  }

  getUsers(blotterType) {
    return this.http.get(this.baseUrl + "api/v1/user/" + blotterType);
  }

  // PUT
  putPurchaseOrderUpdate(id, po_data, parts, comment, validate) {
    return this.http.put(this.baseUrl + "api/v1/po/" + id, {
      po: po_data,
      parts: parts,
      comment: comment,
      isValidation: validate
    });
  }

  putAgreeToTerms() {
    return this.http.put(this.baseUrl + "api/v1/user/terms", {});
  }

  putReprocessFiles(processed_file_ids) {
    return this.http.put(this.baseUrl + "api/v1/admin/reprocess_files/", {
      processed_file_ids: processed_file_ids
    });
  }

  putUpdateFileStatus(processed_file_id, status) {
    return this.http.put(this.baseUrl + "api/v1/admin/update_processed_file/", {
      processed_file_id,
      status
    });
  }

  putUpdateSendFileStatus(processed_file_id, success) {
    return this.http.put(this.baseUrl + "api/v1/admin/send_files/", {
      processed_file_id,
      success
    });
  }

  putRepublishEdi(sent_file_ids) {
    return this.http.put(this.baseUrl + "api/v1/admin/republish_edi/", {
      sent_file_ids: sent_file_ids
    });
  }

  getFileDownload(processed_file_id) {
    return this.http.get(
      `${this.baseUrl}api/v1/admin/processed_file/${processed_file_id}`,
      { responseType: "blob" as "json" }
    );
  }
}
